import { PawPrint, Sparkles } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 6: Prosty i bezpośredni - minimalistyczny z mocnym przekazem
 */
export const InstagramStoryShare6 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      {/* Background image */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "200px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Sparkle icon */}
        <div
          style={{
            background: "rgba(78, 138, 110, 0.15)",
            borderRadius: "50%",
            width: "140px",
            height: "140px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "56px",
          }}
        >
          <Sparkles style={{ width: "72px", height: "72px", color: "#4E8A6E" }} />
        </div>

        {/* Main headline - big and bold */}
        <h1
          style={{
            fontSize: "100px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 40px",
            textAlign: "center",
            lineHeight: 1.1,
          }}
        >
          Daj znać
          <br />
          światu
        </h1>

        {/* Subtitle */}
        <p
          style={{
            fontSize: "46px",
            fontWeight: 600,
            color: "#4A7A5E",
            margin: "0 0 72px",
            textAlign: "center",
            lineHeight: 1.4,
          }}
        >
          że schroniska potrzebują
          <br />
          naszej pomocy
        </p>

        {/* Stats-like element */}
        <div
          style={{
            display: "flex",
            gap: "40px",
            marginBottom: "72px",
          }}
        >
          <div
            style={{
              background: "rgba(255,255,255,0.95)",
              borderRadius: "20px",
              padding: "28px 36px",
              textAlign: "center",
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
            }}
          >
            <p style={{ fontSize: "52px", fontWeight: 800, color: "#2D5A3D", margin: 0 }}>
              500+
            </p>
            <p style={{ fontSize: "24px", fontWeight: 600, color: "#6B8A7A", margin: "8px 0 0" }}>
              schronisk
            </p>
          </div>
          <div
            style={{
              background: "rgba(255,255,255,0.95)",
              borderRadius: "20px",
              padding: "28px 36px",
              textAlign: "center",
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
            }}
          >
            <p style={{ fontSize: "52px", fontWeight: 800, color: "#2D5A3D", margin: 0 }}>
              1000+
            </p>
            <p style={{ fontSize: "24px", fontWeight: 600, color: "#6B8A7A", margin: "8px 0 0" }}>
              zwierząt
            </p>
          </div>
        </div>

        {/* CTA pill */}
        <div
          style={{
            background: "#4E8A6E",
            borderRadius: "50px",
            padding: "24px 56px",
          }}
        >
          <p
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#FFFFFF",
              margin: 0,
            }}
          >
            Udostępnij dalej 💚
          </p>
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "0 80px 100px",
          display: "flex",
          justifyContent: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "52px",
              height: "52px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>
            gdzieschronisko.pl
          </span>
        </div>
      </div>
    </div>
  );
};
